import React from 'react';
import { Link } from 'react-router-dom';
import { RemoteImg } from './RemoteMedia';

export default function CardItem({ to, title, subtitle, meta, image, imageAlt, badge, progress = 0, buttonLabel = 'Học ngay', disabled=false, onClick, actions, noLink=false, linkState }) {
  const Container = (!disabled && !noLink) ? Link : 'div';
  const containerProps = (!disabled && !noLink) ? { to: to || '#', state: linkState } : {};
  return (
    <Container {...containerProps} className="block h-full" onClick={disabled ? onClick : undefined}>
      <div className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-200 p-4 sm:p-5 h-full flex flex-col cursor-pointer">
        {/* Top section: image + info */}
        <div className="flex items-start gap-3 sm:gap-4 flex-1">
          {image ? (
            <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
              <RemoteImg src={image} width={80} alt={imageAlt || title} className="object-cover w-full h-full" />
            </div>
          ) : (
            <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-lg bg-gray-100" />
          )}

          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex-1">
                <h3 className="text-base sm:text-lg font-bold text-gray-900 leading-tight line-clamp-2">{title}</h3>
                {subtitle ? <p className="text-xs sm:text-sm text-gray-500 mt-1 line-clamp-2">{subtitle}</p> : null}
              </div>
              {badge ? (
                <span className="shrink-0 text-xs bg-blue-50 text-blue-600 px-2 py-0.5 rounded-full shadow-sm">{badge}</span>
              ) : null}
            </div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="mt-3">
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-blue-400 h-2 rounded-full transition-all" style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}></div>
          </div>
        </div>

        {/* Bottom section: meta + buttons */}
        <div className="mt-3 flex items-center justify-between gap-2">
          <div className="text-xs sm:text-sm text-gray-500 truncate">{actions ? actions : meta}</div>
          <div className="flex items-center gap-2 shrink-0">
            {disabled ? (
              <button onClick={(e)=>{e.preventDefault(); e.stopPropagation(); onClick && onClick();}} className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow text-sm">{buttonLabel}</button>
            ) : (
              (noLink && to) ? (
                <Link to={to} state={linkState} onClick={(e)=>e.stopPropagation()}>
                  <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow text-sm">{buttonLabel}</button>
                </Link>
              ) : (
                <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow text-sm">{buttonLabel}</button>
              )
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}
